export default function useInitialFilterValues(appliedFilters) {
  const initialValues = {};

  appliedFilters.forEach(filter => {
    const { identifier, value } = filter;

    initialValues[identifier] = value;
  });

  return initialValues;
}
